import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { formatAgo } from '@/lib/ago';

export interface UpdatedLabelProps {
  updatedAt: number | null;
  onRefresh: () => void;
}

/** "Updated 12s ago" label with a manual refresh button. */
export function UpdatedLabel({ updatedAt, onRefresh }: UpdatedLabelProps) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="flex items-center gap-1 text-xs text-muted-foreground">
      <span>{updatedAt == null ? 'Not updated yet' : `Updated ${formatAgo(updatedAt, now)}`}</span>
      <Button variant="ghost" size="icon" onClick={onRefresh} aria-label="Refresh dashboard">
        <RefreshCw aria-hidden />
      </Button>
    </div>
  );
}
